var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#057E9D",
    d: "M168.4,500l336.9-380.9c24.9-24.9,24.9-65.5,0-90.4c-24.9-24.9-65.5-24.9-90.4,0L38.7,453.9c-12.7,12.7-18.7,29.4-18.6,46c-0.1,16.7,5.8,33.4,18.6,46.1l376.1,425.3c24.9,24.8,65.5,24.8,90.4,0s24.9-65.6,0-90.4L168.4,500z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#057E9D",
    d: "M624.2,500l336.6-380.9c25.3-25,25.3-65.6,0.3-90.5c-24.8-24.9-65.6-24.9-90.4,0L494.6,453.9c-12.7,12.7-18.8,29.4-18.6,46c-0.1,16.7,5.8,33.4,18.6,46.1l376,425.3c25,24.8,65.7,24.8,90.4,0c25-24.8,25-65.6,0-90.4L624.2,500z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.1454b185.svg";
export { ForwardRef as ReactComponent };